<template>
	<div class="form-container book-a-demo-form">
		<div id="bookADemoForm"></div>
	</div>
</template>

<script>
	/* eslint-disable */

	export default {
		name: 'Marketo-Form',
    mounted () {
      const script = document.createElement("script");
      script.src="https://js.hsforms.net/forms/v2.js";
      document.body.appendChild(script);

      script.addEventListener("load", () => {
        if (window.hbspt) {
          window.hbspt.forms.create({
          	region: "na1",
            portalId: "9304889",
            formId: "53670384-3625-4e0b-94a0-35db343bc6f7",
            target: "#bookADemoForm"
          })
        }
      })
    }
	}
</script>

<style lang="stylus">
	.form-container 
		width 32%
		min-width 450px
		height auto
		border-radius 20px
		margin-bottom 120px
		padding 60px
		background-color #fff
		
		#hsForm_53670384-3625-4e0b-94a0-35db343bc6f7
			p
				width 100%
				color #333
				margin-bottom 0
				text-align left 
				
			::placeholder
				opacity 1
				
			.hs-form-field
				position relative
				margin-bottom 40px
				
			.hs-company
				margin-bottom 40px
				
			input
				width 100%
				padding 10px
				border 1px solid transparent
				border-bottom 1px solid #ccc
				font-size 13px
				
				&.hs-input.invalid.error
					border 1px solid #FD0000 !important
					
			.hs-error-msgs
				padding 0 0 0 10px
				margin 0
				list-style none
				position absolute
				top 45px
				
				li
					font-size 10px
					
					.hs-error-msg
						color #FD0000
						

			.hs-button.primary.large 
				border none
				width fit-content
				width -moz-fit-content
				background-color #00A562 
				border-radius 30px
				border none !important
				background-image none !important
				padding 12px 60px !important
				box-shadow 0px 20px 40px #00000033
				cursor pointer
				text-align center
				line-height 1.5
				transition all 0.125s ease-in-out
				color #fff
				margin 0 auto 60px
				text-transform uppercase
				font-size 16px !important 
				display block
				
				&:hover
					background-color: #fff
					color #00A562
					
			.hs_error_rollup
				position relative
				display block
				
				ul 
					margin-top 40px
					text-align center
					width 100%
					
			.legal-consent-container 
				margin-bottom 20px 
				
				.hs-richtext p
					padding-bottom 10px
					
				.hs-form-field
					margin-bottom 10px
				
				.hs-form-booleancheckbox-display
					display flex
					
				.input ul 
					list-style none 
					margin 0 
					padding-left 0
				
				li input
					width auto !important 
</style>